import EntityOverviewCard from "../UI/EntityOverviewCard";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import transparentLogo from "../../transparent-logo.png";

const Img = styled("img")({
  display: "block",
  maxWidth: "80px",
  maxHeight: "80px",
  objectFit: "contain",
});

const SeasonOverview = ({ season }) => (
  <EntityOverviewCard
    testId="seasonOverview"
    image={
      <Box>
        <Img
          alt={season.competition?.name || "Competition"}
          src={season.competition?.url || "/static/images/url.jpg"}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = transparentLogo;
          }}
        />
      </Box>
    }
    fields={[
      { label: "Name", value: season.name },
      { label: "Competition", value: season.competition?.name },
      { label: "Start Date", value: season.startDate },
      { label: "End Date", value: season.endDate },
    ]}
  />
);

export default SeasonOverview;
